import React from 'react';
import { Button } from '@/components/ui/button';
import { Mail, Trophy, XCircle, CheckCircle } from 'lucide-react';

const CommitteeAccessRequestsTab = ({
  accessRequests,
  reviewAccessRequest
}) => {
  return (
    <div className="bg-white rounded-lg border border-slate-200">
      <div className="p-4 border-b border-slate-200">
        <h3 className="font-semibold text-slate-900">Access Requests</h3>
        <p className="text-sm text-slate-500">Review applicant requests to access your scholarships</p>
      </div>
      
      {accessRequests.length === 0 ? (
        <div className="p-8 text-center">
          <Mail className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-600">No access requests yet</p>
        </div>
      ) : (
        <div className="divide-y divide-slate-200">
          {accessRequests.map((request) => (
            <div key={request.id} className="p-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-medium text-slate-900">{request.user_name}</h4>
                    <span className={`px-2 py-0.5 rounded-full text-xs ${
                      request.status === 'pending' 
                        ? 'bg-yellow-100 text-yellow-700'
                        : request.status === 'approved'
                          ? 'bg-green-100 text-green-700'
                          : 'bg-red-100 text-red-700'
                    }`}>
                      {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                    </span>
                    {request.is_previous_recipient && (
                      <span className="px-2 py-0.5 rounded-full text-xs bg-amber-100 text-amber-700 flex items-center gap-1">
                        <Trophy className="w-3 h-3" />
                        Previous Recipient
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-slate-500">{request.user_email}</p>
                  <p className="text-sm text-slate-500 mt-1">
                    Scholarship: {request.scholarship_name}
                  </p>
                  <p className="text-xs text-slate-400 mt-1">
                    Submitted: {new Date(request.created_at).toLocaleString()}
                  </p>
                  {request.previous_awards_count > 0 && (
                    <p className="text-xs text-amber-600 mt-1">
                      Has received {request.previous_awards_count} scholarship(s) previously
                    </p>
                  )}
                </div>
                
                {request.status === 'pending' && (
                  <div className="flex items-center gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => reviewAccessRequest(request.id, request.token, false)}
                      className="border-red-300 text-red-600 hover:bg-red-50"
                    >
                      <XCircle className="w-4 h-4 mr-1" />
                      Deny
                    </Button>
                    <Button
                      size="sm"
                      onClick={() => reviewAccessRequest(request.id, request.token, true)}
                      className="bg-green-600 hover:bg-green-700"
                    >
                      <CheckCircle className="w-4 h-4 mr-1" />
                      Approve
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommitteeAccessRequestsTab;